import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import zhHant from 'vuetify/es5/locale/zh-Hant'
import en from 'vuetify/es5/locale/en'
import Cookies from 'js-cookie'

const lang = Cookies.get('lang')

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#4FB786',
        secondary: '#56CB94',
        accent: '#212121',
        error: '#FF6C77',
        info: '#2EA6FF',
        success: '#66CB53',
        warning: '#FEDA88'
      }
    }
  },
  lang: {
    locales: { 'zh-TW': zhHant, en },
    current: lang || process.env.VUE_APP_I18N_LOCALE
  }
})
